/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取娱伯牙文章内容分页列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class SearchYbyContentListPageParams {
  constructor(
    public page: number,
    public pageSize: number,
    public searchType: number,
    public performanceType?: string
  ) {}
}

export default async function (
  params: SearchYbyContentListPageParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.Page<cms.YbyContentListVO>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/yby/page`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
